import { j as l } from "../../jsx-runtime-BwWtxLpl.js";
import w from "classnames";
import { useContext as $, useRef as v, useReducer as ee, useEffect as N } from "react";
import e from "prop-types";
import { MotifTooltipOverlay as te } from "./tooltip-overlay/tooltip-overlay.js";
import { MotifTooltipContent as oe } from "./tooltip-content/tooltip-content.js";
import le from "./placementOptions.js";
import "../button/button.js";
import "../dropdown-portal/dropdown-portal.js";
import { MotifIcon as ie } from "../icon/icon.js";
import { IconContext as ne } from "../icon/icon.context.js";
import { MotifHardwareIcKeyboardArrowDown24px as se } from "@ey-xd/motif-icon";
import { MotifIconButton as ce } from "../button/icon-button/icon-button.js";
const C = "SHOW_TOOLTIP", f = "HIDE_TOOLTIP", O = "SET_FOCUS", y = "HIDE_BLUR", T = "SHOW_FOCUS", re = {
  show: !1,
  focus: !1,
  clicked: !1
}, ae = (p, b) => {
  const { focus: n, show: s, clicked: u } = p, { type: d, clicked: i = u } = b;
  switch (d) {
    case C:
      return { focus: n, show: !0, clicked: i };
    case f:
      return { focus: n, show: !1, clicked: i };
    case O:
      return { focus: !0, show: s, clicked: i };
    case y:
      return { focus: !1, show: !1, clicked: i };
    case T:
      return { focus: !0, show: !0, clicked: i };
    default:
      return p;
  }
}, fe = {
  close: se
}, P = (p) => {
  const {
    id: b = "tooltip",
    variant: n = "default",
    trigger: s = null,
    placement: u = "auto",
    children: d,
    contentClassName: i = "",
    hide: r = !1,
    flip: D = !0,
    closeButtonProps: F = {},
    allowClick: g = !0,
    allowHover: x = !0,
    forceHideCounter: M = 0,
    hideCloseButton: U = !1,
    hideArrow: A = !1,
    icons: H = {},
    offset: I = { left: "14px", top: "2px" },
    style: L = {}
  } = p, { tooltip: j } = $(ne);
  let m;
  j ? m = {
    ...j,
    ...H
  } : m = {
    ...fe,
    ...H
  };
  const E = (t, a) => !!(a && a.target && t && t.current && !t.current.contains(a.target)), h = v(null), B = v(null), [c, o] = ee(ae, re);
  N(() => (window.addEventListener("click", S), () => window.removeEventListener("click", S)), []), N(() => {
    o({ type: f, clicked: !1 });
  }, [M]);
  const S = (t) => {
    E(B, t) && E(h, t) && o({ type: y, clicked: !1 });
  }, R = () => {
    if (!g)
      return;
    const t = !c.clicked;
    c.focus ? r || o({ type: C, clicked: t }) : o(r ? { type: O, clicked: t } : { type: T, clicked: t });
  }, W = () => o({ type: f, clicked: !1 }), z = () => {
    g && o(r ? { type: O } : { type: T });
  }, K = () => {
    c.clicked || o({ type: y, clicked: !1 });
  }, V = (t) => {
    t.key === "Escape" && o({ type: f });
  }, q = () => {
    x && !r && o({ type: C });
  }, G = () => {
    x && !c.clicked && o({ type: f, clicked: !1 });
  }, _ = !r && c.show, J = U ? null : /* @__PURE__ */ l.jsx(
    ce,
    {
      "aria-label": "Click here to close tooltip",
      type: "button",
      onClick: W,
      ...F,
      children: /* @__PURE__ */ l.jsx(ie, { iconFunction: m.close })
    }
  ), Q = w({
    "motif-tooltip-wrapper": !0,
    "motif-tooltip-alternate": n === "alt"
  }), X = w({
    "motif-tooltip-trigger-wrap": !0,
    "motif-tooltip-clicked": c.clicked,
    "motif-tooltip-variant-link": s && s.props && s.props.variant === "link",
    "motif-tooltip-show": _,
    "motif-tooltip-alternate": n === "alt"
  }), Y = w({
    "motif-tooltip-content": !0,
    "motif-tooltip-alternate": n === "alt",
    "motif-tooltip-placement-left": u === "left",
    [i]: !0
  }), k = {
    right: { position: "left", size: I.left },
    bottom: { position: "top", size: I.top }
  };
  return /* @__PURE__ */ l.jsxs("span", { className: Q, "data-motif-tooltip": !0, children: [
    /* @__PURE__ */ l.jsx(
      "span",
      {
        className: X,
        ref: h,
        onFocus: z,
        onBlur: K,
        onKeyDown: V,
        onPointerEnter: q,
        onPointerLeave: G,
        onClick: R,
        children: s
      }
    ),
    /* @__PURE__ */ l.jsx(te, { target: h.current, show: _, placement: u, flip: D, children: (t) => {
      const a = Object.keys(k).some((Z) => Z === t.placement) ? {
        ...t,
        style: t.style && {
          ...t.style,
          [k[t.placement].position]: k[t.placement].size
        }
      } : t;
      return /* @__PURE__ */ l.jsx("div", { role: "tooltip", className: Y, ref: B, style: L, children: /* @__PURE__ */ l.jsxs(oe, { hideArrow: A, ...a, children: [
        /* @__PURE__ */ l.jsx("div", { "aria-live": "polite", className: "motif-tooltip-content-children", children: d }),
        J
      ] }) });
    } })
  ] });
};
P.propTypes = {
  /**
   * Tooltip id
   */
  id: e.oneOfType([e.string, e.number]),
  /**
   * Tooltip variant
   */
  variant: e.oneOf(["default", "alt"]),
  /**
   * React element to be used as trigger
   */
  trigger: e.oneOfType([e.element, e.elementType]),
  /**
   * Tooltip placement
   */
  placement: e.oneOf(le),
  /**
   * Custom CSS classes to override content styling.
   */
  contentClassName: e.string,
  /**
   * Tooltip content
   */
  children: e.node,
  /**
   *  Whether to hide the tooltip or not
   */
  hide: e.bool,
  /**
   * Whether to flip the tooltip when it starts to overlap the target element
   */
  flip: e.bool,
  /**
   * Props to be passed to the close button
   */
  closeButtonProps: e.instanceOf(Object),
  /**
   * Custom styles to override component styling.
   */
  style: e.instanceOf(Object),
  /**
   * Whether to allow the tooltip to show on click or not
   */
  allowClick: e.bool,
  /**
   * Whether to allow the tooltip to show on hover or not
   */
  allowHover: e.bool,
  /**
   * Visible tooltip will hide when this prop changes. Tooltip functionality will remain active.
   */
  forceHideCounter: e.number,
  /**
   * Whether to hide the close button or not
   */
  hideCloseButton: e.bool,
  /**
   * Offset of the tooltip
   */
  offset: e.shape({
    left: e.number,
    top: e.number
  }),
  /**
   * Whether to hide the arrow or not
   */
  hideArrow: e.bool,
  /**
   * Custom icons to override default icons.
   */
  icons: e.shape({
    close: e.node
  })
};
P.defaultProps = {
  id: "tooltip",
  variant: "default",
  trigger: null,
  placement: "auto",
  contentClassName: "",
  children: null,
  hide: !1,
  flip: !0,
  closeButtonProps: {},
  style: {},
  allowClick: !0,
  allowHover: !0,
  forceHideCounter: 0,
  hideCloseButton: !1,
  hideArrow: !1,
  icons: {}
};
export {
  P as MotifTooltip
};
